var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mx-column-data',{staticStyle:{"height":"100%"},attrs:{"config":_vm.config,"dataconfig":_vm.dataconfig},on:{"change":_vm.OnChange}},[[_vm._t("default",function(){return [_c('Panel',{attrs:{"config":_vm.config,"data":_vm.Data,"list":_vm.List,"index":_vm.index}})]},{"data":_vm.Data,"list":_vm.List})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }